import { axiosClient } from '@/features'
import { ApiRoutes } from '@/routes'
import { ReferralResponse } from '@/features/Referral/referral.types'

export const referralService = {
  getReferralAmount: async () => {
    const req = await axiosClient.get<ReferralResponse>(ApiRoutes.REFERRAL_PROGRAM_AMOUNT)
    return req.data
  },

  claim: async (cardId: string) => {
    const req = await axiosClient.post(`${ApiRoutes.REFERRAL_PROGRAM_CLAIM}?cardId=${cardId}`)
    return req.data
  },

  applyReferralCode: async (code: string) => {
    const req = await axiosClient.post(ApiRoutes.REFERRAL_PROGRAM_APPLY, {
      code
    })
    return req.data
  }
}
